import createReducer from '../utils/createReducer';
import ActionTypes from '../constants/ActionTypes';

const storeList = createReducer(
  { bunnings: [] },
  {
    [ActionTypes.STORE_LOCATION_SUCCESS]: (state, { payload }) => {
      return {
        bunnings: payload
      };
    }
  }
);

export default storeList;
